import { InjectionToken } from '@angular/core';

/**
 * Injection Token für die {@link DEFAULT_FILE_UPLOAD_MIME_TYPES_MAPPING} für Dependency Injection.
 *
 * <b>Das ist keine Allow-List für erlaubte Dateitypen und nur eine Hilfe für die
 * Anzeige der erlaubten Dateitypen!</b>
 */
export const FILE_UPLOAD_MIME_TYPES_MAPPING = new InjectionToken('FILE_UPLOAD_MIME_TYPES', {
    providedIn: 'root',
    factory: () => DEFAULT_FILE_UPLOAD_MIME_TYPES_MAPPING
});

/**
 * Default MIME-Type-Mappings für die {@link FileUploadComponent} in SPP.
 * Key: "jpeg" in "image/jpeg" oder "plain" in "text/plain"
 * Value: Dateiendungen, die zum Hochladen erlaubt werden.
 *
 * <b>Das ist keine Allow-List für erlaubte Dateitypen und nur eine Hilfe für die
 * Anzeige der erlaubten Dateitypen!</b>
 *
 * Notwendig für die Anzeige der zugehörigen Dateiendungen zu MIME-Types die anders
 * lauten als die Dateiendung sowie für alle MIME-Types (Bsp: PPTX), für die es verschiedene/
 * mehrere mögliche Dateieindungen gibt (Bsp: jpeg)
 *
 *
 * Wenn die {@link FileUploadComponent} beispielsweise PPTX-Dateien hochladen will
 * muss in den Mime-Types der Komponente "'vnd.openxmlformats-officedocument.presentationml.presentation'
 * angegeben sein, so dass dann die Dateiendung "pptx" angezeigt werden kann. Das ist so, da wir
 * an der Komponente MIME-Types und nicht Dateiendungen erlauben.
 */
const DEFAULT_FILE_UPLOAD_MIME_TYPES_MAPPING: { [index: string]: string } = {
    'comma-separated-values': 'csv',
    'octet-stream': 'bin,exe,com,dll,class',
    'vnd.ms-excel': 'xls,xla',
    'vnd.ms-powerpoint': 'ppt,ppz,pps,pot',
    'vnd.openxmlformats-officedocument.presentationml.presentation': 'pptx',
    'vnd.openxmlformats-officedocument.spreadsheetml.sheet': 'xlsx',
    'vnd.openxmlformats-officedocument.wordprocessingml.document': 'docx',
    'x-midi': 'mid,midi',
    'x-mpeg': 'mp2,mp3',
    'x-msvideo': 'avi',
    'x-wav': 'wav',
    'x-zip-compressed': 'zip',
    'xhtml+xml': 'htm,html,shtml,xhtml',
    html: 'htm,html,shtml',
    javascript: 'js',
    jpeg: 'jpg,jpeg,jpe',
    mpeg: 'mpeg,mpg,mpe,mp3',
    msword: 'doc,dot',
    plain: 'txt',
    tiff: 'tiff,tif',
};
